export default __webpack_public_path__ + "static/media/warning.8c772da4.png";